import React, { useState } from 'react';
import { View } from 'react-native';

import RelayTable from 'app/src/elements/Table/RelayTable';
import { Title, Text } from 'app/src/styles';
import { dateShort } from 'app/src/utils/formatting';
import { Link } from 'app/src/utils/routing';

import { MEDICINES } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'client',
    label: 'Client',
    value: ({ value }) => value.name,
  },
  {
    key: 'alternateNames',
    label: 'Alt. Name(s)',
  },
  {
    key: 'emoji',
    label: 'Emoji',
  },
  {
    key: 'doseAmount',
    label: 'Dose',
    content: ({ entry }) => (
      [entry.doseAmount, entry.doseType].filter(value => value).join(' ')
    )
  },
  {
    key: 'startOn',
    label: 'Start Date',
    content: dateShort,
  },
  {
    key: 'endOn',
    label: 'Stop Date',
    content: dateShort,
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/medicines/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const Medicines = () => {
  const [refetch, setRefetch] = useState();

  return (
    <View>
      <Title>Medicines</Title>

      <Link to="/medicines/new">
        <Text>Add Medicine</Text>
      </Link>

      <RelayTable
        query={MEDICINES}
        queryName="medicines"
        columns={columns}
        setRefetch={setRefetch}
      />
    </View>
  );
};

export default Medicines;
